<template>
    <v-card relative class="image-view mb-5">
        <v-card-title class="pa-1">
            <h3 class="" style="width: 100%; text-align: center">{{ image.view }}</h3>
        </v-card-title>
        <v-img class="preview"
               :src="image.src && image.src.length > 0 ? image.src : '/img/no-image.svg'"
               aspect-ratio="0.57" @click="toggleEdit()"
        >
            <template v-slot:placeholder>
                <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                >
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
            </template>
            <div v-if="showEdit" class="edit-container">
                <v-btn fab light :color="'primary'" @click.stop.prevent="rotateImage()">
                    <v-icon large light>mdi-rotate-left-variant</v-icon>
                </v-btn>
                <v-btn fab small light :color="'secondary'" class="mt-5">
                    <v-icon light>mdi-close</v-icon>
                </v-btn>
            </div>
        </v-img>
        <v-btn v-if="image.image_type > -1 && showEdit === false" fab light small absolute :bottom="true" style="left: -20px; margin-left: 50%;" :color="processing.color" @click="openUpload">
            <v-icon light>{{ processing.icon }}</v-icon>
        </v-btn>
        <v-btn v-if="image.image_type < 0 && image.status != 'edit'" fab light small absolute :bottom="true" style="left: -20px; margin-left: 50%;" :color="processing.color">
            <v-icon light>{{ processing.icon }}</v-icon>
        </v-btn>
        <input v-if="image.image_type > -1" v-show="false" ref="inputUpload" type="file" @change="getPhoto" accept="image/*" >
    </v-card>
</template>


<script>

    import orientation from '../scripts/js-exif-rotate'

    export default {
        mounted () {

            var that = this
            this.$store.watch(
                (state) => state.data.photoType,
                (newValue, oldValue) => {
                    //console.log('photoType', that.image.image_type, newValue, oldValue, that.image.src)
                    if(that.image.src === undefined)
                        setTimeout(() => that.getImageSrc(), 500)
                }
            )

            if(that.image.src === undefined)
                setTimeout(() => that.getImageSrc(), 500)


        },
        props: [
            'image'
        ],
        data () {
            return {
                rotation: 0,
                showEdit: false
            }
        },
        name: 'imageUpload',
        methods: {
            openUpload (){
                this.$refs.inputUpload.click()
                this.showEdit = false
            },
            rotateImage () {
                this.$store.dispatch('data/rotateImage', this.image)
                this.showEdit = false
            },
            toggleEdit () {
                if(!this.image.src || this.image.src.length < 1 || this.image.id < 1) return this.showEdit = false
                this.showEdit = !this.showEdit
            },
            getImageSrc () {
                this.$store.dispatch('data/getImage',this.image.view)
            },
            getPhoto (event) {

                this.image.status = 'loading'

                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it


                var that = this;

                if (input.files && input.files[0]) {

                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader()
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {

                        orientation(input.files[0], function(srcOrientation) {
                            //$('#placeholder1').attr('src', base64img);
                            //console.log('rotate', srcOrientation)
                            //var rotated = $('#placeholder2').attr('src', base64img);
                            /*
                            if(value) {
                                rotated.css('transform', rotation[value]);
                            }
                            */
                            that.rotation = srcOrientation
                            var img = new Image();

                            img.onload = function() {
                                var width = img.width,
                                    height = img.height,
                                    canvas = document.createElement('canvas'),
                                    ctx = canvas.getContext("2d");


                                canvas.width = width;
                                canvas.height = height;
/*
                                // set proper canvas dimensions before transform & export
                                if (4 < srcOrientation && srcOrientation < 9) {
                                    canvas.width = height;
                                    canvas.height = width;
                                } else {
                                    canvas.width = width;
                                    canvas.height = height;
                                }

                                // transform context before drawing image
                                switch (srcOrientation) {
                                    case 2:
                                        ctx.transform(-1, 0, 0, 1, width, 0);
                                        break;
                                    case 3:
                                        ctx.transform(-1, 0, 0, -1, width, height);
                                        break;
                                    case 4:
                                        ctx.transform(1, 0, 0, -1, 0, height);
                                        break;
                                    case 5:
                                        ctx.transform(0, 1, 1, 0, 0, 0);
                                        break;
                                    case 6:
                                        ctx.transform(0, 1, -1, 0, height, 0);
                                        break;
                                    case 7:
                                        ctx.transform(0, -1, -1, 0, height, width);
                                        break;
                                    case 8:
                                        ctx.transform(0, -1, 1, 0, 0, width);
                                        break;
                                    default:
                                        break;
                                }

*/
                                // draw image
                                ctx.drawImage(img, 0, 0);

                                // export base64
                                //console.log('img1', canvas.toDataURL(), that.image);
                                that.image.src = canvas.toDataURL('image/jpeg', 0.5)

                                that.$store.dispatch('data/uploadImage', that.image)
                                event.target.files = null
                            }

                            img.src = e.target.result;

                        });

                        // Note: arrow function used here, so that "this.src" refers to the src of Vue component
                        // Read image as base64 and set to src
                        //this.image.src = e.target.result



                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0])
                }
            }
        },
        computed: {
            processing () {
                switch(this.image.status) {
                    default:
                        return {
                            color: 'primary',
                            icon: 'photo_camera'
                        }
                    case 'loading':
                        return {
                            color: 'default',
                            icon: 'schedule'
                        }
                    case 'success':
                        return {
                            color: 'success',
                            icon: 'check_circle'
                        }
                }

                return processing
            }
        }
    }
</script>

<style scoped lang="scss">

    .image-view {
        .preview {
            border: 1px solid #ddd;
        }
        .v-card__title {
            font-family: Roboto, sans-serif;
            text-transform: uppercase;
            color: #222;
            background: #ddd;
            display: flex;
            justify-content: center;
            h3 {
                margin: 0;
                padding: 0;
                font-size: 14px;
                font-weight: 300;
            }

        }
        .v-responsive {
            background: #DDD9D3;
        }

        .edit-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: rgba(0,0,0,0.4);
        }
    }
</style>
